<template>
  <div class="whole">
    <div class="clearFix">
      <div class="left_item">
        <div class="title-layout title">
          <div style="width:2px;margin-left:8px;float:left;background: #ffffff;height: 100%;"></div>
          <div style="width:100px;float:left;height: 100%;">
            <span>&nbsp;临近天气</span>
          </div>
        </div>
        <div class="border-layout1" style="padding: 20px 30px">
          <div class="text-title1">
            <img :src="position_pic" alt="">
            <span>短时临近：{{ threeHourTitle }}</span>
          </div>
          <div class="clearFix">
            <div class="weather-left-layout">
              <div class="weather-time">{{ nearLeftTime }}</div>
              <div class="weather-container">
                <img v-bind:src="nearLeftImg" alt="">
                <span>{{ nearLeftTemp }}</span>
              </div>
              <div class="weather-info">{{ nearLeftInfo }}</div>
              <div class="weather-wind">{{ nearLeftWind }}</div>
            </div>
            <div class="weather-right-layout">
              <div class="weather-time">{{ nearRightTime }}</div>
              <div class="weather-container">
                <img v-bind:src="nearRightImg" alt="">
                <span>{{ nearRightTemp }}</span>
              </div>
              <div class="weather-info">{{ nearRightInfo }}</div>
              <div class="weather-wind">{{ nearRightWind }}</div>
            </div>
          </div>
        </div>
        <div class="title-layout titlee" style="margin-top: 5px">
          <div style="width:2px;margin-left:8px;float:left;background: #ffffff;height: 100%;"></div>
          <span class="titext ">
            &nbsp;未来6小时
             <span v-bind:class="{title_right: true, 'selectColor': weatherType === 'wind'}"
                   v-on:click="changeType(3)">风力</span>
            <span v-bind:class="{title_right: true, 'selectColor': weatherType === 'rain'}"
                  v-on:click="changeType(2)">降水</span>
            <span v-bind:class="{title_right: true, 'selectColor': weatherType === 'temp'}"
                  v-on:click="changeType(1)">气温</span>
          </span>

        </div>
        <div class="border-layout2" style="padding: 20px 30px">
          <div class="text-title2">
            <div>{{ sixHourTitle }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ sixHourType }}</div>
          </div>
          <div class="table-layout">
            <img v-bind:src="imageType" alt="">
            <div class="table">
              <div :id="id" :option="option" style="width: 100%; height: 100%"></div>
            </div>
          </div>
          <div class="location-address1">{{ address1 }}</div>
          <div class="location-address2">{{ address2 }}</div>
        </div>
      </div>
      <div class="right_item">
        <div class="title-layout title">
          <span>&nbsp;一周预报</span>
        </div>
        <div class="border-layout3">
          <div class="border-laypot4" style="padding: 20px 30px">
            <div class="text-title1">
              <img :src="position_pic" alt="">
              <span>{{ weekHourTitle }}</span>
            </div>
            <div class="clearFix">
              <div class="weather-left-layout">
                <div class="weather-time">{{ weekLeftTime }}</div>
                <div class="weather-container">
                  <img v-bind:src="weekLeftImg" alt="">
                  <span>{{ weekLeftTemp }}</span>
                </div>
                <div class="weather-info">{{ weekLeftInfo }}</div>
                <div class="weather-wind">{{ weekLeftWind }}</div>
              </div>
              <div class="weather-right-layout">
                <div class="weather-time">{{ weekRightTime }}</div>
                <div class="weather-container">
                  <img v-bind:src="weekRightImg" alt="">
                  <span>{{ weekRightTemp }}</span>
                </div>
                <div class="weather-info">{{ weekRightInfo }}</div>
                <div class="weather-wind">{{ weekRightWind }}</div>
              </div>
            </div>
          </div>
          <div class="weather-week-btnn">
            <span v-bind:class="{weekBtn: true, 'weekBtnSelect': (key === weekIndex)}" v-for="(item, key) in btnTime"
                  v-bind:key="key" v-on:click="weekSelect(key)">{{ item }}</span>
          </div>
          <div>
            <div class="weather-week-day">
              <div class="week-line-pic" v-for="(item, key) in weekLineDayPic" v-bind:key="key">
                <img v-bind:src="item" alt="">
              </div>
            </div>
            <div class="line" id="line">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="146">
                <g>
                  <!--eslint-disable-next-line-->
                  <rect v-for="item in rectArray" :x="(100/7 * item)+'%'" y="0" :width="(100 / 7)+'%' " height="146"
                        class="rectCSS"></rect>
                  <!--eslint-disable-next-line-->
                  <text v-for="item in textD" class="textCssD" :x="item.x" :y="item.y">{{ item.v }}℃</text>
                  <!--eslint-disable-next-line-->
                  <text v-for="item in textN" class="textCssN" :x="item.x" :y="item.y">{{ item.v }}℃</text>
                  <!--eslint-disable-next-line-->
                  <path v-bind:d="arrayDLine" class="pathCssD"></path>
                  <!--eslint-disable-next-line-->
                  <path v-bind:d="arrayNLine" class="pathCssN"></path>
                  <!--eslint-disable-next-line-->
                  <circle v-for="item in pointD" class="pointCssD" :cx="item.x" :cy="item.y" r="3.5"></circle>
                  <!--eslint-disable-next-line-->
                  <circle v-for="item in pointN" class="pointCssN" :cx="item.x" :cy="item.y" r="3.5"></circle>
                </g>
              </svg>
            </div>
            <div class="weather-week-night">
              <div class="week-line-pic" v-for="(item, key) in weekLineNightPic" v-bind:key="key">
                <img v-bind:src="item" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title-layout title" style="margin-top: 10px">
      <div style="width:2px;margin-left:8px;float:left;background: #ffffff;height: 100%;"></div>
      <span>&nbsp;降水预报</span>
    </div>
    <div class="border-layout4 clearFix">
      <div class="image-line">
        <div class="image-layout">
          <router-link tag="a" target="_blank" :to="{ path: '/weatherr'}">
            <img v-bind:src="pic1Path" v-on:error="onPicError()" alt="">
          </router-link>
        </div>
        <div class="image-layout">
          <router-link tag="a" target="_blank" :to="{ path: '/weather/pricterr'}">
            <img v-bind:src="pic2Path" v-on:error="onPicError()" alt="">
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import position_pic from '../assets/image/position.png'
import imageTemp from '../assets/image/temp_graph1.png'
import imageRain from '../assets/image/rain_graph1.png'
import imageWind from '../assets/image/wind_graph1.png'
import myChart from 'highcharts'
import default_pic from '../assets/image/default_pic.png'

export default {
  data() {
    return {
      code: this.$store.state.code,
      name: this.$store.state.name,

      position_pic: position_pic,
      threeHourTitle: '',
      nearLeftTime: '',
      nearRightTime: '',
      nearLeftInfo: '',
      nearLeftWind: '',
      nearRightInfo: '',
      nearRightWind: '',
      nearLeftTemp: '',
      nearRightTemp: '',
      nearLeftImg: '',
      nearRightImg: '',
      weatherType: 'temp',

      sixHourTitle: '',
      sixHourType: '单位:℃',
      imageTemp: imageTemp,
      imageRain: imageRain,
      imageWind: imageWind,
      imageType: imageTemp,
      id: 'id',
      option: {
        chart: {
          type: 'spline',
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        legend: {
          enabled: false//是否允许有图注
        },
        yAxis: {
          title: {
            text: null,
          },
          visible: false,
        },
        credits: {
          enabled: false//不显示LOGO
        },
        xAxis: {
          categories: [],
          crosshair: true,
          lineColor: '#000',
          lineWidth: 2,
          tickColor: '#000',
          tickWidth: 2,
          tickmarkPlacement: 'on',
          labels: {
            style: {
              color: '#000', fontSize: '13px', fontWeight: '700'
            }
          }
        },
        tooltip: {
          enabled: false//数据提示框
        },
        plotOptions: {
          column: {
            pointWidth: 5,
          },
          series: {
            dataLabels: {
              enabled: true,
              format: '{y}',
              style: {
                fontSize: '14px',
                fontFamily: 'sans-serif',
                fontWeight: '700',
              },
            }
          }
        },
        series: [{
          animation: false,
          data: [],
          dataLabels: {
            align: 'center',
            enabled: true,
            //crop: false,
            //overflow: 'none',
          },
        }]
      },
      address1: '',
      address2: '',

      weekHourTitle: '',
      weekLeftTime: '',
      weekRightTime: '',
      weekLeftInfo: '',
      weekLeftWind: '',
      weekRightInfo: '',
      weekRightWind: '',
      weekLeftTemp: '',
      weekRightTemp: '',
      weekLeftImg: '',
      weekRightImg: '',
      weekArrayData: [],
      weekIndex: 0,
      btnTime: [],
      is17: '',
      weekLineDayPic: [],
      weekLineNightPic: [],
      arrayD: [],
      arrayN: [],
      textD: [],
      textN: [],
      arrayDLine: '',
      arrayNLine: '',
      pointD: [],
      pointN: [],
      rectArray: [0, 1, 2, 3, 4, 5, 6],
      pic1Path: default_pic,
      pic2Path: default_pic,
    }
  },
  mounted: function () {
  },
  created: function () {
    this.getThreeHourData(this.code)
    this.getSixHourData(this.code)
    this.getWeekData(this.code)
    this.getWeatherPic1();
    this.getWeatherPic2();
  },
  methods: {
    getThreeHourData: function (code) {
      this.$post('Get6HAction.action?areaCode=' + code)
          .then(res => {
            let result = res.result[0]
            let date2 = result.date2
            let array1 = date2.split(';')
            for (let i = 0; i < array1.length; i++) {
              let array = array1[i].split(',')
              if (array[1] === code) {
                this.nearLeftTime = this.name + '  ' + array[2]
                this.nearRightTime = this.name + '  ' + array[11]
                this.nearLeftTemp = array[4] + '~' + array[5] + '℃'
                this.nearRightTemp = array[13] + '~' + array[14] + '℃'
                this.nearLeftInfo = array[6]
                this.nearLeftWind = array[7] + ' ' + array[8]
                this.nearRightInfo = array[15]
                this.nearRightWind = array[16] + ' ' + array[17]
                this.nearLeftImg = require('@/assets/approach/' + array[3])
                this.nearRightImg = require('@/assets/approach/' + array[12])
                this.threeHourTitle = array[9].split('#')[0] + ' ' + result.times + ' 发布'
              }
            }
          }).catch((error) => {
        console.error('临近天气错误' + error)
      })
    },
    getSixHourData: function (code) {
      this.$post('PositionWeatherAction.action?&lon=0&lat=0&ysType=' + this.weatherType + '&area=' + code)
          .then(res => {
            let result = (res.resultList)[0]
            this.sixHourTitle = result.skdec + ' : ' + result.skData
            this.address1 = result.M
            this.address2 = result.MC
            let data = result.yb
            let array = data.split('::')
            for (let i = 0; i < array.length; i++) {
              if (this.weatherType === 'rain') {
                this.option.xAxis.categories[i] = (array[i].split(','))[0] + '(h)'
                this.option.series[0].data[i] = Number((array[i].split(','))[1])
              } else {
                this.option.xAxis.categories[i] = (array[i].split(','))[0] + ':00'
                this.option.series[0].data[i] = Number((array[i].split(','))[1])
              }
            }
            myChart.chart(this.id, this.option)
          }).catch((error) => {
            console.error(error)
          }
      )
    },
    changeType: function (index) {
      switch (index) {
        case 1:
          this.weatherType = 'temp'
          this.sixHourType = '单位:℃'
          this.imageType = this.imageTemp
          break
        case 2:
          this.weatherType = 'rain'
          this.sixHourType = '单位:mm'
          this.imageType = this.imageRain
          break
        case 3:
          this.weatherType = 'wind'
          this.sixHourType = '单位:级'
          this.imageType = this.imageWind
          break
      }
      this.getSixHourData(this.code)
    },
    getWeekData: function (code) {
      this.$post('Get168sHAction.action?code=999999')
          .then(res => {
            let result = res.result[0]
            let gqx168time = result.gqx168time
            this.is17 = (gqx168time.split(' ')[1]).split(':')[0]
            let areaData = ''
            for (let i = 0; i < result.data.length; i++) {
              if (result.data[i].code === code) {
                areaData = result.data[i]
              }
            }
            this.weekHourTitle = areaData.unit + result.times + ' 发布  '
            this.btnTime = result.time.split(',')
            for (let i = 0; i < 15; i++) {
              this.$set(this.weekArrayData, i, areaData[(i + 1) * 12])
            }
            this.weekSelect(0)
            for (let i = 0; i < 14; i++) {
              if ((i % 2) === 0) {
                this.$set(this.weekLineDayPic, i / 2, require(`@/assets/week/${this.weekArrayData[i].split("##")[4]}`));
              } else {
                this.$set(this.weekLineNightPic, (i - 1) / 2, require(`@/assets/week/${this.weekArrayData[i].split("##")[4]}`));
              }
            }

            let stringD = areaData[12].split('##')[1] + ',' + areaData[36].split('##')[1] + ',' + areaData[60].split('##')[1] + ',' + areaData[84].split('##')[1] + ',' + areaData[108].split('##')[1] + ',' + areaData[132].split('##')[1] + ',' + areaData[156].split('##')[1]
            for (let i = 0; i < stringD.split(",").length; i++) {
              this.$set(this.arrayD, i, Number(stringD.split(',')[i]))
            }
            let stringN = areaData[24].split('##')[1] + ',' + areaData[48].split('##')[1] + ',' + areaData[72].split('##')[1] + ',' + areaData[96].split('##')[1] + ',' + areaData[120].split('##')[1] + ',' + areaData[144].split('##')[1] + ',' + areaData[168].split('##')[1]
            for (let i = 0; i < stringN.split(",").length; i++) {
              this.$set(this.arrayN, i, Number(stringN.split(',')[i]))
            }
            let max = this.getMaxValue()
            let min = this.getMinValue()
            let ratio = 80 / (max - min)

            let line = document.getElementById("line");
            let width = line.offsetWidth;

            for (let i = 0; i < this.arrayD.length; i++) {
              let cx = (width / 14 * ((i * 2) + 1))
              let value = Math.abs(this.arrayD[i] - max)

              let ty = (value * ratio) + 18
              this.$set(this.textD, i, {x: cx, y: ty, v: this.arrayD[i]})

              let py = (value * ratio) + 33
              this.$set(this.pointD, i, {x: cx, y: py})
            }
            for (let i = 0; i < this.arrayN.length; i++) {
              let cx = (width / 14 * ((i * 2) + 1))
              let value = Math.abs(this.arrayN[i] - max)

              let ty = (value * ratio) + 51
              this.$set(this.textN, i, {x: cx, y: ty, v: this.arrayN[i]})

              let py = (value * ratio) + 33
              this.$set(this.pointN, i, {x: cx, y: py})
            }
            //直线
            /*this.arrayDLine = 'M'
            this.arrayNLine = 'M'
            for (let i = 0; i < this.pointD.length; i++) {
              this.arrayDLine = this.arrayDLine + this.pointD[i].x + ',' + this.pointD[i].y + ' ';
            }
            for (let i = 0; i < this.pointN.length; i++) {
              this.arrayNLine = this.arrayNLine + this.pointN[i].x + ',' + this.pointN[i].y + ' ';
            }*/
            //带贝塞尔曲线
            this.arrayDLine = ''
            this.arrayNLine = ''
            for (let i = 0; i < this.pointD.length - 1; i++) {
              this.arrayDLine = this.arrayDLine + this.creatPoint(this.pointD[i], this.pointD[i + 1])
            }
            for (let i = 0; i < this.pointN.length - 1; i++) {
              this.arrayNLine = this.arrayNLine + this.creatPoint(this.pointN[i], this.pointN[i + 1])
            }
          }).catch((error) => {
        console.error(error)
      })
    },
    creatPoint: function (sP, eP) {
      let l1 = 'M ' + sP.x + ',' + sP.y + ' '
      let l3 = eP.x + ',' + eP.y + ' '
      let x1 = sP.x + (eP.x - sP.x) / 3.00000999
      let x2 = eP.x - (eP.x - sP.x) / 3.00000999
      let p1 = x1 + ',' + sP.y + ' '
      let p2 = x2 + ',' + eP.y + ' '
      let l2 = 'C ' + p1 + p2
      return l1 + l2 + l3
    },
    getMaxValue: function () {
      let max1 = Math.max.apply(null, this.arrayD)
      let max2 = Math.max.apply(null, this.arrayN)
      if (max1 >= max2) {
        return max1
      } else {
        return max2
      }
    },
    getMinValue: function () {
      let min1 = Math.min.apply(null, this.arrayD)
      let min2 = Math.min.apply(null, this.arrayN)
      if (min1 >= min2) {
        return min2
      } else {
        return min1
      }
    },
    weekSelect: function (index) {
      this.weekIndex = index
      let dataArray1
      let dataArray2
      if (Number(this.is17) >= 17) {
        dataArray1 = this.weekArrayData[2 * index + 1].split('##')
        dataArray2 = this.weekArrayData[2 * index + 2].split('##')
        this.weekLeftTime = this.name + ' ' + Number(this.btnTime[index].substring(0, 2)) + '日 夜间'
        let day = this.getDate();
        let day1 = Number(this.btnTime[index].substring(0, 2)) + 1;
        if (day1 > day) {
          day1 = 1;
        }
        this.weekRightTime = this.name + ' ' + day1 + '日 白天';
      } else {
        dataArray1 = this.weekArrayData[2 * index].split('##')
        dataArray2 = this.weekArrayData[2 * index + 1].split('##')
        this.weekLeftTime = this.name + ' ' + Number(this.btnTime[index].substring(0, 2)) + '日 白天'
        this.weekRightTime = this.name + ' ' + Number(this.btnTime[index].substring(0, 2)) + '日 夜间'
      }
      this.weekLeftInfo = dataArray1[0]
      this.weekRightInfo = dataArray2[0]
      this.weekLeftWind = dataArray1[2] + dataArray1[3]
      this.weekRightWind = dataArray2[2] + dataArray2[3]
      this.weekLeftTemp = dataArray1[1] + '℃'
      this.weekRightTemp = dataArray2[1] + '℃'
      this.weekLeftImg = require('@/assets/approach/' + dataArray1[4])
      this.weekRightImg = require('@/assets/approach/' + dataArray2[4])
    },
    getDate: function () {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let d = new Date(year, month, 0);
      return d.getDate();
    },
    onPicError: function (index) {
      switch (index) {
        case 1:
          this.pic1Path = default_pic;
          break
        case 2:
          this.pic2Path = default_pic;
          break
      }
    },
    getWeatherPic1: function () {
      this.$post("RainArea_bj.action", "", false)
          .then(res => {
            let result = res.Result;
            for (let i = 0; i < result.length; i++) {
              if (result[i].url !== "") {
                this.pic1Path = result[i].url;
                break;
              }
            }
          }).catch((error) => {
        console.error(error);
      })
    },
    getWeatherPic2: function () {
      this.$post("RainArea_nation.action", "", false)
          .then(res => {
            let result = res.Result;
            for (let i = 0; i < result.length; i++) {
              if (result[i].url !== "") {
                this.pic2Path = result[i].url;
                break;
              }
            }
          }).catch((error) => {
        console.error(error);
      })
    },
  },
  watch: {
    '$store.state.code': function (newCode, oldCode) {
      console.log(newCode + ":" + oldCode)
      this.code = newCode
      this.name = this.$store.state.name
      this.getThreeHourData(this.code)
      this.getSixHourData(this.code)
      this.getWeekData(this.code)
    },
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>

.main-layout {
  width 100%;
  height auto;
  margin-top 5px;
  margin-bottom 5px;
}

.title-left {
  float left;
  margin-left 20px;
}

.title_right {
  font-size 15px
  text-decoration underline;
  float right;
  margin-right 20px;
  cursor pointer;
}

.left_item {
  width 50%
  float left;
}

.right_item {
  width 50%
  float right;
}

.title {
  width 100%;
  background-color: #4595E6;
}

.border-layout1 {
  border 1px solid #aaa
  margin-top: 2px;
  height 175px;
  overflow auto
}

.border-layout2 {
  border 1px solid #aaa
  margin-top 2px
  height 220px;
}

.border-layout3 {
  border 1px solid #aaa
  margin-top 2px;
  height 518px;
  overflow auto

  .border-laypot4 {
    height 180px;
  }
}

.border-layout4 {
  border 1px solid #aaa
  margin-top 2px
}

.text-title1 {
  font-size 15px;
  text-align left
  height 20px;
  line-height 20px;

  img {
    width auto;
    height 20px;
    vertical-align: middle;
  }

  span {
    display inline-block;
    vertical-align: middle;
    color #003366
    margin-left 15px;
    font-weight bold;
  }
}

.text-title2 {
  font-size 15px;
  text-align left
  height 20px;
  line-height 20px;
  font-weight bold;
}

.weather-left-layout {
  width 50%
  float left
  margin 0 auto
  text-align left
}

.weather-right-layout {
  width 50%
  float right
  margin 0 auto
  text-align left
}

.weather-time,
.weather-info,
.weather-wind {
  margin-left 3em
  font-size 14px
  font-weight bold
  margin-top 15px
}

.weather-container {
  margin-top 15px
  margin-left 3em

  span {
    font-weight bold
    font-size 27px
    color #0059b3
    vertical-align: middle;
  }

  img {
    vertical-align: middle;
    height 35px
    width auto
  }
}

.selectColor {
  color: #FFD400;
}

.table-layout {
  margin-top 10px;
  text-align left;
  height 150px;
  display: flex
  flex-direction: row

  img {
    margin-top 30px
    margin-bottom 30px
    height 70px
    width 35px;
  }

  .table {
    display inline-block;
    flex 1;
  }
}

.location-address1 {
  text-align left;
  font-size: 15px;
  font-weight bold;
}

.location-address2 {
  text-align right;
  font-size: 15px;
  font-weight bold;
}

.weather-week-btn
.weather-week-day,
.weather-week-night {
  display: flex
  flex-direction: row
}

.weekBtn {
  text-decoration underline
  cursor pointer
  color white
  flex 1;
  font-size 15px
  font-weight bold
}

.weekBtnn {
  /* text-decoration underline
   cursor pointer*/
  color #0059b3
  flex 1;
  font-size 13px
  font-weight bold
}

.weekBtnSelect {
  color: #ffd400;
}

.week-line-pic {
  flex: 1;
  vertical-align middle

  img {
    margin: 8px 22px;
    /*margin 0 auto*/
    vertical-align middle
  }
}

.line {
  height 146px;
  text-align left;
}

.pathCssD {
  fill: none;
  stroke: #FF8000;
  stroke-width: 2.099999;
  stroke-linejoin: round;
  stroke-linecap: round;
  cursor: pointer;
}

.pathCssD:hover {
  stroke-width: 3;
}

.pathCssN {
  fill: none;
  stroke: #000066;
  stroke-width: 2.099999;
  stroke-linejoin: round;
  stroke-linecap: round;
  cursor: pointer;
}

.pathCssN:hover {
  stroke-width: 3;
}

.pointCssD {
  stroke: #FF8000;
  stroke-width: 1;
  fill: #FF8000;
  cursor: pointer;
  r: 3.5;
}

.pointCssD:hover {
  stroke-width: 3;
  stroke: #FF800099;
  r: 6;
}

.pointCssN {
  stroke: #000066;
  stroke-width: 1;
  fill: #000066;
  cursor: pointer;
  r: 3.5;
}

.pointCssN:hover {
  stroke-width: 3;
  stroke: #00006699;
  r: 6;
}

.textCssD {
  font-size: 15px;
  dominant-baseline: middle;
  text-anchor: middle;
  fill: #FF8000;
  cursor: pointer;
  font-weight 700;
}

.textCssN {
  font-size: 15px;
  dominant-baseline: middle;
  text-anchor: middle;
  fill: #000066;
  cursor: pointer;
  font-weight 700;
}

.rectCSS {
  fill white;
}

.rectCSS:hover {
  fill #F2F5FA;
}

.image-line {
  display inline-block
  width 100%
}

.image-layout {
  display inline-block
  width: 30%;
  text-align center
  margin: 20px 9%;

  img {
    width: 353px;
    height: 309px;
    border: 1px solid #aaa;
    cursor: pointer;
  }

  span {
    font-size 15px;
    text-decoration underline
    color black
    font-weight bold
  }
}

.weather-week-btnn {
  line-height: 34px;
  background: #4595e6bf;
  width: 100%;
  font-weight: 800;
  display: flex
  text-align: center;
  flex-direction: row;
  margin-bottom: 18px;
  // margin-top 5px;
}

.titlee {
  width: 100%;
  background-color: #4595e6bf;
}
</style>

